import React, { Component } from 'react';
import ReactPaginate from 'react-paginate';
import { Link } from 'react-router-dom';
import Cookies from 'js-cookie';
import '../Pagination.css';
import '../Alumnos/MDAlumnos.css';
import * as constantClass from '../fileWithConstants';
import { runMdMutation, isMdMutationLocked } from '../../services/mdMutationGuard';
import { MD_PAGE_SIZE, fetchAndApplyIndexPage } from '../../services/mdServerIndex';
import { ConfirmDialog } from '../common/ConfirmDialog';
import {
  MdRowActions,
  MdTableActionsCell,
  MdTableCell,
  MdTableHeaderCell,
} from '../common/MdRowActions';
import { PlusIcon, SearchIcon } from '../common/mdPageIcons';

function getEstadoInscripcion(estado) {
  if (estado === 'A') return 'Activa';
  if (estado === 'P') return 'Pendiente';
  if (estado === 'G') return 'Acta Generada';
  return 'Lista';
}

function getEstadoBadgeClass(estado) {
  if (estado === 'P') return 'md-page__badge md-page__badge--warning';
  if (estado === 'A') return 'md-page__badge md-page__badge--success';
  if (estado === 'G') return 'md-page__badge md-page__badge--info';
  return 'md-page__badge';
}

function getResultadoLabel(resultado) {
  const value = (resultado || '').trim();
  if (!value) return 'Sin resultado';
  return value;
}

function getResultadoBadgeClass(resultado) {
  const value = (resultado || '').trim().toLowerCase();
  if (value === 'regular' || value === 'r') return 'md-page__badge md-page__badge--success';
  if (value === 'libre' || value === 'l') return 'md-page__badge md-page__badge--danger';
  return 'md-page__badge md-page__badge--neutral';
}

export class MDInscripcionCursadaAlumno extends Component {
  static displayName = MDInscripcionCursadaAlumno.name;

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      searchInput: '',
      perPage: MD_PAGE_SIZE,
      paginationData: [],
      totalCount: 0,
      pageCount: 0,
      offset: 0,
      currentPage: 0,
      showErrorMessage: false,
      errorMessage: '',
      successMessage: '',
      deletingId: null,
      pendingDelete: null,
    };
    this.searchInputRef = React.createRef();
  }

  componentDidMount() {
    if (constantClass.canAccess('InscribirCursada')) {
      this.populateData();
    }
  }

  handleRemoveItem = (periodo) => {
    if (isMdMutationLocked(this)) return;
    this.setState({
      pendingDelete: {
        id: periodo.inscripcionCursadaCod,
        nombre: periodo.materia,
      },
    });
  };

  handleCancelDelete = () => {
    if (this.state.deletingId) return;
    this.setState({ pendingDelete: null });
  };

  handleConfirmDelete = () => {
    const { pendingDelete } = this.state;
    if (!pendingDelete || isMdMutationLocked(this)) return;
    this.deleteItem(pendingDelete.id);
  };

  handlePageClick = (e) => {
    this.populateData(e.selected, this.state.searchInput);
  };

  handleSearchInputChange = (e) => {
    const searchInput = e.target.value;
    const cleared = searchInput.trim() === '';
    this.setState({ searchInput, successMessage: '', showErrorMessage: false, errorMessage: '' });
    if (cleared && this.state.searchInput.trim() !== '') {
      this.populateData(0, '', { background: false });
    }
  };

  clearFeedback = () => {
    this.setState({ successMessage: '', showErrorMessage: false, errorMessage: '' });
  };

  handleSearchSubmit = (e) => {
    e.preventDefault();
    const search = (this.searchInputRef.current
      ? this.searchInputRef.current.value
      : this.state.searchInput).trim();
    this.setState({ searchInput: search });
    this.populateData(0, search, { background: false });
  };

  buildRowActions(periodo) {
    const id = periodo.inscripcionCursadaCod;
    const estado = periodo.inscripcionCursadaEstado;
    const actions = [];

    if (estado === 'P' || estado === 'A') {
      actions.push({
        key: 'edit',
        label: 'Modificar',
        variant: 'primary',
        icon: 'pencil',
        to: '/update-ica/' + id + '/0',
      });
      actions.push({
        key: 'delete',
        label: this.state.deletingId === id ? 'Eliminando...' : 'Borrar',
        variant: 'danger',
        icon: 'trash',
        onClick: () => this.handleRemoveItem(periodo),
        disabled: this.state.loading || this.state.deletingId === id,
      });
    }

    actions.push({
      key: 'detail',
      label: 'Detalles',
      variant: 'outline',
      icon: 'info',
      to: '/update-ica/' + id + '/1',
    });

    return actions;
  }

  renderTable(periodos) {
    return (
      <div className="md-page__table-card">
        <table className="md-page__table md-page__table--actions-fixed" aria-labelledby="md-inscripcion-cursada-alumno-title">
          <thead>
            <tr>
              <MdTableHeaderCell cellType="text">Carrera</MdTableHeaderCell>
              <MdTableHeaderCell cellType="text">Materia</MdTableHeaderCell>
              <MdTableHeaderCell cellType="date">Fecha de Inscripción</MdTableHeaderCell>
              <MdTableHeaderCell cellType="text" className="md-page__table__badge-cell">Estado de Inscripción</MdTableHeaderCell>
              <MdTableHeaderCell cellType="text" className="md-page__table__badge-cell">Resultado</MdTableHeaderCell>
              <th scope="col" className="md-page__table__actions-header" aria-label="Acción" />
            </tr>
          </thead>
          <tbody>
            {periodos.map((periodo) => (
              <tr key={periodo.inscripcionCursadaCod}>
                <MdTableCell cellType="text">{periodo.carrera}</MdTableCell>
                <MdTableCell cellType="text">{periodo.materia}</MdTableCell>
                <MdTableCell cellType="date">{constantClass.formatDisplayDate(periodo.inscripcionCursadaFechaHora)}</MdTableCell>
                <MdTableCell cellType="text" className="md-page__table__badge-cell">
                  <span className={getEstadoBadgeClass(periodo.inscripcionCursadaEstado)}>
                    {getEstadoInscripcion(periodo.inscripcionCursadaEstado)}
                  </span>
                </MdTableCell>
                <MdTableCell cellType="text" className="md-page__table__badge-cell">
                  <span className={getResultadoBadgeClass(periodo.resultado)}>
                    {getResultadoLabel(periodo.resultado)}
                  </span>
                </MdTableCell>
                <MdTableActionsCell>
                  <MdRowActions items={this.buildRowActions(periodo)} />
                </MdTableActionsCell>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  render() {
    const isBusy = this.state.loading || this.state.searching;
    const listLoading = this.state.loading && !this.state.deletingId;
    const { pendingDelete } = this.state;

    const contents = listLoading
      ? <p className="md-page__loading"><em>Cargando datos...</em></p>
      : this.renderTable(this.state.paginationData);

    return (
      <div className="md-page md-inscripcion-cursada-alumno">
        <h1 id="md-inscripcion-cursada-alumno-title" className="md-page__title">Manejar Datos de Inscripciones a Cursadas</h1>

        <div className="md-page__feedback" aria-live="polite" role="status">
          {this.state.showErrorMessage ? (
            <div className="md-page__error" role="alert">
              {this.state.errorMessage}
            </div>
          ) : null}
          {this.state.successMessage ? (
            <div className="md-page__success">{this.state.successMessage}</div>
          ) : null}
        </div>

        <div className="md-page__toolbar">
          <Link className="md-page__action-link" to="/add-ica">
            <PlusIcon />
            Nueva Inscripción
          </Link>
        </div>

        <form className="md-page__search-row" onSubmit={this.handleSearchSubmit}>
          <div className="md-page__search-wrap">
            <span className="md-page__search-icon">
              <SearchIcon />
            </span>
            <input
              ref={this.searchInputRef}
              className="md-page__search-input"
              type="text"
              name="search"
              autoComplete="off"
              disabled={isBusy}
              placeholder="Ingrese Materia"
              value={this.state.searchInput}
              onChange={this.handleSearchInputChange}
            />
          </div>
          <button type="submit" className="md-page__search-btn" disabled={isBusy}>
            Buscar
          </button>
        </form>

        {contents}

        {!listLoading && this.state.pageCount > 0 ? (
          <div className="md-page__pagination">
            <ReactPaginate
              previousLabel="Anterior"
              nextLabel="Siguiente"
              breakLabel="..."
              breakClassName="break-me"
              pageCount={this.state.pageCount}
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              forcePage={Math.floor(this.state.offset / this.state.perPage)}
              onPageChange={this.handlePageClick}
              containerClassName="pagination"
              subContainerClassName="pages pagination"
              activeClassName="active"
            />
          </div>
        ) : null}

        <ConfirmDialog
          open={Boolean(pendingDelete)}
          title="Darse de baja de la materia"
          message="¿Desea darse de baja de la materia seleccionada? Esta acción no se puede deshacer."
          detail={pendingDelete ? pendingDelete.nombre : ''}
          confirmLabel="Confirmar baja"
          cancelLabel="Cancelar"
          variant="danger"
          loading={Boolean(this.state.deletingId)}
          onConfirm={this.handleConfirmDelete}
          onCancel={this.handleCancelDelete}
        />
      </div>
    );
  }

  async populateData(page = 0, search = '', options = {}) {
    await fetchAndApplyIndexPage(this, {
      indexUrl: 'api/ic/Index/' + JSON.parse(Cookies.get('alumnoCodigos')),
      page,
      search: typeof search === 'string' ? search.trim() : '',
      perPage: this.state.perPage,
      background: options.background,
    });
  }

  async deleteItem(id) {
    this.clearFeedback();
    this.setState({ deletingId: id });
    await runMdMutation(this, async () => {
      const { data } = await constantClass.apiFetch('api/ic/delete/' + id, {
        method: 'POST',
      });
      if (data === 'Timeout') {
        constantClass.RedirectToLogin();
        return;
      }
      if (constantClass.isApiError(data)) {
        this.setState({
          showErrorMessage: true,
          errorMessage: constantClass.getApiErrorMessage(
            data,
            'No se pudo dar de baja la materia. Intente nuevamente.'
          ),
          pendingDelete: null,
        });
        return;
      }
      this.setState({ successMessage: 'Se registró la baja de la materia correctamente.', pendingDelete: null });
      await this.populateData(this.state.currentPage, this.state.searchInput);
    });
    this.setState({ deletingId: null });
  }
}
